<template>
  <main class="layout-auth">
    <section class="close" @click="onClick">
      <Icon collection="v2" icon="cross" :size="iconSize" />
    </section>
    <Nuxt />
  </main>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Icon from '~/components/components/icon/Icon.vue';
import { useInitPage } from '~/composables/use-init-page';

const page = useInitPage();
const router = useRouter();

const iconSize = computed(() => (page.isMobile.value ? 'xs' : 's'));

function onClick() {
  router.push('/');
}
</script>

<style lang="scss" scoped>
.layout-auth {
  min-height: 100vh;
  background: $main-back-color;

  .close {
    position: fixed;
    top: 32px;
    right: 32px;
    width: 64px;
    height: 64px;
    background: $color-white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    @include mobile {
      top: 16px;
      right: 16px;
      width: 32px;
      height: 32px;
    }
  }
}
</style>
